import assign from 'object-assign';
import axios from './request';
import globalServices from './api';

const api = {};
const IS_MOCK = window.location.href.indexOf('localhost') !== -1 || window.location.href.indexOf('me.mock') !== -1;
const urlsAllThere = {};
api.getUrl = (key) => urlsAllThere[key].url;
export const generator = (urls) => {
    const mergedUrls = {
        ...globalServices,
        ...urls,
    };
    const generalUrl = (key) => {
        const {
            method,
            url,
            mockUrl,
            isJSon,
            responseType
        } = mergedUrls[key];

        if (IS_MOCK) {
            return {
                method: method || 'get',
                url: mockUrl || url,
                isJSon,
            };
        }
        return {
            method,
            url,
            isJSon,
            responseType,
        };
    };

    Object.keys(mergedUrls).forEach((item) => {
        urlsAllThere[item] = mergedUrls[item];
        const localItem = generalUrl(item);
        const { method } = localItem;
        switch (String(method).toUpperCase()) {
            case 'POST':
            case 'PUT':
            case 'PATCH':
                api[item] = (params) => axios(assign({}, localItem, {
                    data: params,
                }));
                break;
            default:
                api[item] = (params) => axios(assign({}, localItem, {
                    params,
                }));
        }
    });

    return api;
};

generator(globalServices);

export default api;


// WEBPACK FOOTER //
// ./src/services/index.js